import Box from '@mui/material/Box';
import NextImage from 'next/image';
import type { SxProps } from '@mui/material/styles';

export default function Image({
  src,
  alt,
  aspectRatio,
  sx,
  sizes = '(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw',
  width = '100%',
  height = '100%',
  onClick,
  quality = 90,
}: {
  src: string;
  alt: string;
  aspectRatio?: string;
  sx?: SxProps;
  sizes?: string;
  width?: string;
  height?: string;
  onClick?: () => void;
  quality?: number;
}) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: width || '100%',
        height: height || '100%',
        aspectRatio,
        overflow: 'hidden',
        '& img': {
          objectFit: 'cover',
        },
        ...sx,
      }}
      onClick={onClick}
    >
      <NextImage src={src} alt={alt} fill sizes={sizes} quality={quality} />
    </Box>
  );
}
